module.exports = "/static/assets/e53ff4a140871927b2d5be4f5cdb2c79.svg";